import { atom, Atom } from "../lib/atom-crdt"

export type PollCRDT = Readonly<{
  candidates: Slate
  ballots: BallotBox
  title: Atom<string>
  initial: boolean
}>

export function emptyPoll(): PollCRDT {
  return { title: atom(""), initial: true, candidates: {}, ballots: {} }
}

export type Candidate = {
  id: string
  content: Content
}

export type Content = string | null // TODO: can this be made non-nullable?

export type Slate = {
  [id: string]: Content
}

export function alphabetically(a: string, b: string) {
  return a < b
}

export type CandidateID = string

export function ballot(ballotSet: BallotBox, agentID: string): Ballot {
  return ballotSet[agentID] || atom([])
}

export type Ballot = Atom<string[]>
export type BallotBox = { [agentID: string]: Ballot }
